import { useEffect, useState } from "react";
import DashboardShell from "@/components/layout/DashboardShell";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { Store, Users, Wallet, CalendarRange, FileText, Beef, CloudOff, RefreshCw } from "lucide-react";

const fmtINR = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(Number(n) || 0);

function Tile({ icon: Icon, label, value, testId }) {
  return (
    <div className="am-card p-5 flex items-center gap-4" data-testid={testId}>
      <div className="w-11 h-11 rounded-2xl bg-accent text-primary grid place-items-center shrink-0"><Icon className="w-5 h-5" /></div>
      <div className="min-w-0">
        <div className="font-display text-2xl font-extrabold truncate">{value}</div>
        <div className="text-xs text-muted-foreground">{label}</div>
      </div>
    </div>
  );
}

export default function SubscriberCombined() {
  const { t } = useT();
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/subscriber/combined-dashboard").then((r) => setD(r.data)).catch(() => {});
  }, []);

  if (!d) return <DashboardShell title={t("nav.combined")}><div className="text-sm text-muted-foreground py-10 text-center">{t("common.loading")}</div></DashboardShell>;

  return (
    <DashboardShell title={t("nav.combined")} subtitle={t("haat.combinedSubtitle")}>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Tile icon={Store} label={t("haat.totalHaats")} value={d.total_haats} testId="combined-total-haats" />
        <Tile icon={Users} label={t("haat.totalHelpers")} value={d.total_helpers} testId="combined-total-helpers" />
        <Tile icon={Wallet} label={t("haat.todayCollection")} value={fmtINR(d.today_collection)} testId="combined-today-collection" />
        <Tile icon={CalendarRange} label={t("haat.monthlyCollection")} value={fmtINR(d.monthly_collection)} testId="combined-monthly-collection" />
        <Tile icon={FileText} label={t("haat.todayRegistrations")} value={d.today_registrations} testId="combined-today-registrations" />
        <Tile icon={Beef} label={t("haat.totalAnimals")} value={d.total_animals} testId="combined-total-animals" />
        <Tile icon={RefreshCw} label={t("haat.pendingSync")} value={d.pending_sync} testId="combined-pending-sync" />
        <Tile icon={CloudOff} label={t("haat.offlineDevices")} value={d.offline_devices} testId="combined-offline-devices" />
      </div>

      <div className="am-card p-2 overflow-x-auto mt-6">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs uppercase tracking-widest text-muted-foreground border-b">
              <th className="px-4 py-3">Pashu Haat</th>
              <th className="px-4 py-3">{t("haat.todayCollection")}</th>
              <th className="px-4 py-3">{t("haat.todayRegistrations")}</th>
              <th className="px-4 py-3">{t("haat.todayAnimals")}</th>
              <th className="px-4 py-3">{t("haat.activeHelpers")}</th>
            </tr>
          </thead>
          <tbody>
            {d.per_haat.map((h) => (
              <tr key={h.haat_id} className="border-b last:border-0" data-testid={`combined-haat-row-${h.haat_id}`}>
                <td className="px-4 py-3 font-semibold">{h.name}</td>
                <td className="px-4 py-3 font-mono">{fmtINR(h.today_collection)}</td>
                <td className="px-4 py-3 font-mono">{h.today_registrations}</td>
                <td className="px-4 py-3 font-mono">{h.today_animals}</td>
                <td className="px-4 py-3 font-mono">{h.active_helpers}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </DashboardShell>
  );
}
